module.exports = __webpack_public_path__ + "img/1080_21.2e5ad590.jpg";